import StorageView from './StorageView';
export default StorageView;
